import FullPageLayout from "@jnctn/design-system/Layout/FullPageLayout.component";
import Loader from "@jnctn/design-system/Loader/Loader.component";

export default function LoadingPage({ type = "white" }: { type?: "white" | "black" }) {
  return (
    <FullPageLayout direction="vertical" type={type}>
      <Loader color={type === "black" ? "white" : "black"} />
    </FullPageLayout>
  );
}
